/**
 * The KPI Library Access page: which library it is showing.
 *
 * The page draws a panel of plan cards per library and the server picks the one
 * to show, from the same book preference the nav's menu holds, so the page is
 * already right before this runs. Choosing the other tab swaps the panel, the
 * name the comparison table gives the library, and the product every action
 * carries into the plans modal.
 *
 * It deliberately does not reload or write the preference: the nav's menu is
 * where that is decided, and a visitor comparing the two libraries here is not
 * saying which one they work in.
 */

function accessLibrarySwitch() {
    const page = document.querySelector('.access-page[data-library]');

    if (! page) {
        return;
    }

    const tabs = Array.from(document.querySelectorAll('[data-library-tab]'));

    function show(library) {
        page.dataset.library = library;

        tabs.forEach((tab) => {
            tab.setAttribute('aria-pressed', tab.dataset.libraryTab === library ? 'true' : 'false');
        });

        page.querySelectorAll('[data-library-panel]').forEach((panel) => {
            panel.hidden = panel.dataset.libraryPanel !== library;
        });

        // Scoped to the page: the modal draws the same table inside each
        // library's panel, and those answer to the panel, not to this switch.
        page.querySelectorAll('[data-library-only]').forEach((element) => {
            element.hidden = element.dataset.libraryOnly !== library;
        });

        // The table's own ways in are drawn once per library, inside the spans
        // above, so the one on screen already names the right one.
    }

    tabs.forEach((tab) => {
        tab.addEventListener('click', () => show(tab.dataset.libraryTab));
    });
}

document.addEventListener('DOMContentLoaded', accessLibrarySwitch);
